<!-- *ngIf="successLoadData" -->
<div class="biggest-container">
  <mat-card class="example-card">
    <mat-card-content>
      <mat-toolbar style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        " color="primary">Article
        <div style="display: flex; gap: 10px">
          <div class="image-container">
            <img *ngIf="generalService.cuurentUser == 'SNCT'" (click)="generateExcel()" src="assets/Excel.png
        " alt="Liste categorie" height="40" width="52" class="hover-Image" />
            <div class="hover-text">Liste Article</div>
          </div>
          <div class="image-container">
            <img *ngIf="generalService.cuurentUser == 'SNCT'" (click)="generateExcelCat()" src="assets/Excel.png
        " alt="Liste categorie" height="40" width="52" class="hover-Image" />
            <div class="hover-text">liste Catégories</div>
          </div>
        </div>
      </mat-toolbar>

      <ng-template #attente>
        <br />
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </ng-template>
      <div *ngIf="enregistrementTerminer; else attente"></div>
      <form class="example-form" #f="ngForm">
        <mat-tab-group [selectedIndex]="index" (selectedIndexChange)="index = $event" (animationDone)="tabChanged()">
          <mat-tab label="Information article">
            <br />
            <div class="display-flex">
              <div style="width: 60%">
                <mat-form-field style="width: calc(25% - 10px); margin-right: 5px">
                  <input [disabled]="typeTrs != '1'" matInput name="Art_Code" #Art_Code="ngModel"
                    (input)="removeSpecialCarater()" [(ngModel)]="article.Art_Code" placeholder="Code article"
                    required />
                </mat-form-field>
                <mat-form-field style="width: 75%; margin-right: 5px">
                  <input matInput [disabled]="disabled" name="Art_Des" #Art_Des="ngModel" [(ngModel)]="article.Art_Des"
                    placeholder="Désignation article " required />
                </mat-form-field>
                <div>
                  <mat-form-field style="width: 45%; margin-right: 4%">
                    <input matInput [disabled]="disabled" name="Art_Defs4" #Art_Des4="ngModel" [(ngModel)]="text[0][0]"
                      placeholder="Désignation article français" />
                  </mat-form-field>
                  <mat-form-field style="width: 50%">
                    <input matInput [disabled]="disabled" name="ArtDesAnglais" #ArtDesAnglais="ngModel"
                      [(ngModel)]="text[1][0]" placeholder="Désignation article anglais" />
                  </mat-form-field>
                </div>
                <div>
                  <mat-form-field style="width: 40%; margin-left: 5px">
                    <textarea matInput [(ngModel)]="article.Art_Commentaire" name="Art_Commentaire"
                      placeholder="Commentaire" style="margin-left: 10px"></textarea>
                  </mat-form-field>
                </div>
              </div>
              <div style="width: 40%">
                <mat-form-field style="margin-right: 10px; width: 70px">
                  <input matInput [disabled]="disabled" name="Art_PV" type="number" #Art_PV="ngModel"
                    [(ngModel)]="article.Art_PV" placeholder="Prix" required />
                </mat-form-field>
                <mat-form-field style="margin-right: 10px; width: 70px">
                  <input matInput [disabled]="disabled" name="Art_PV1" type="number" #Art_PV1="ngModel"
                    [(ngModel)]="article.Art_PV1" placeholder="Ancien prix" />
                </mat-form-field>
                <mat-form-field style="width: 100px; margin-right: 10px">
                  <mat-select name="etat" #etat="ngModel" [(ngModel)]="article.Art_Status" placeholder="&Eacute;tat"
                    required>
                    <mat-option value="1">Active</mat-option>
                    <mat-option value="0">Inactive</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field style="width: 120px">
                  <input matInput [disabled]="disabled" name="Art_Garantie" #Art_Garantie="ngModel"
                    [(ngModel)]="article.Art_Garantie" placeholder="Durée de garantie" />
                </mat-form-field>
                <mat-form-field style="margin-right: 10px; width: 70px">
                  <input matInput [disabled]="disabled" name="Art_Poids" type="number" #Art_Poids="ngModel"
                    [(ngModel)]="article.Art_Poids" placeholder="Poids" required />
                </mat-form-field>
                <mat-form-field style="width: 100px; margin-right: 10px">
                  <mat-select name="promo" #promo="ngModel" [(ngModel)]="article.Art_Stat5" placeholder="Promo"
                    required>
                    <mat-option value="1">Active</mat-option>
                    <mat-option value="0">Inactive</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field *ngIf="generalService.cuurentUser == 'SNCT'" style="width: 100px; margin-right: 10px">
                  <input matInput [disabled]="disabled" name="SiteWeb" #Art_Des="ngModel"
                    [(ngModel)]="article.Art_Stat4" placeholder="SiteWeb " />
                </mat-form-field>
                <br />
                <mat-form-field style="width: 50%; margin-right: 10px">
                  <input matInput [disabled]="disabled" name="Art_CodeCpt" #Art_CodeCpt="ngModel"
                    [(ngModel)]="article.Art_CodeCpt" [placeholder]="
                      generalService.cuurentUser == 'BIGDAR'
                        ? 'Référence internationale'
                        : 'Unité'
                    " />
                </mat-form-field>
                <mat-form-field style="width: 80px">
                  <input matInput [disabled]="disabled" type="number" name="Art_DL" #Art_DL="ngModel"
                    [(ngModel)]="article.Art_DL" placeholder="Livraison" />
                </mat-form-field>
                <div *ngIf="generalService.cuurentUser == 'BIGDAR'" style="
                    display: flex;
                    gap: 15px;
                    justify-content: center;
                    align-items: center;
                    padding: 5px;
                  ">
                  <div style="cursor: pointer" (click)="importerMarque('input_Marque')">
                    <img id="30_30" [src]="
                        lastEvent == 'upload'
                          ? imageMarqueSrc
                          : generalService.base_url +
                            'images/' +
                            article.Art_Marque
                      " width="60px" height="60px" alt="Marque" style="margin-right: 10px" />

                    <input id="input_Marque" type="file" value="importer" style="display: none"
                      (change)="onChangeImageMarque($event)" />
                  </div>
                  <span style="margin-right: 20px" class="button-row">
                    <button type="button" (click)="SupprimerMarque()" [disabled]="disabled" class="coloViolet"
                      mat-raised-button>
                      Supprimer Marque
                    </button>
                  </span>
                </div>
                <div *ngIf="generalService.cuurentUser == 'SNCT'" style="
                    display: flex;
                    gap: 15px;
                    justify-content: center;
                    align-items: center;
                    padding: 5px;
                  ">
                  <mat-form-field style="width: 100px; margin-right: 10px">
                    <mat-select name="Pertinence" [(ngModel)]="article.Art_Variante1" placeholder="Pertinence" required>
                      <mat-option value="1">Oui</mat-option>
                      <mat-option value="0">Non</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <br />
                <br /><br />
                <mat-radio-group class="example-radio-group" name="Art_Stock" [(ngModel)]="article.Art_Stock">
                  <mat-radio-button style="margin-right: 10px" *ngFor="let etat of typeEtatStock" [value]="etat.value">
                    {{ etat.text }}
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <mat-accordion [multi]="true">
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    Tableau de description / Bref description
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="display-flex">
                  <div style="width: 65%">
                    <h4>Bref description</h4>
                    <div class="display-flex">
                      <div class="txt">
                        <!-- <quill-editor [config]="editorConfig" name="tex1" placeholder="Fr"
                          [(ngModel)]="article.Art_Des1">
                        </quill-editor> -->
                        <quill-editor class="brief-editor" #quillEditorRef [(ngModel)]="article.Art_Des1" format="html"
                          [modules]="quillModules" theme="snow" (onContentChanged)="logValue(article.Art_Des1)"
                          style="height: 400px">
                        </quill-editor>
                      </div>
                      <!-- <div class="txt">
                        <quill-editor
                          [config]="editorConfig"
                          name="tex2"
                          placeholder="En"
                          [(ngModel)]="text[1][1]"
                        >
                        </quill-editor>
                      </div> -->
                    </div>
                  </div>
                  <div style="width: 35%">
                    <h4>Tableau de description</h4>
                    <ckeditor [config]="{
                        toolbar: {
                          items: [
                            'heading',
                            '|',
                            'alignment',
                            'bold',
                            'italic',
                            'link',
                            'bulletedList',
                            'numberedList',
                            'blockQuote',
                            'undo',
                            'redo'
                          ]
                        }
                      }" [editor]="Editor" name="Art_Des3" [(ngModel)]="article.Art_Des3" #Art_Des1j="ngModel"
                      style="height: 300px">
                    </ckeditor>
                  </div>
                </div>
              </mat-expansion-panel>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title> Description détaillée 1 </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="display-flex">
                  <div class="txt">
                    <quill-editor class="ql-container" [modules]="quillModules" name="tesx1" placeholder="Fr"
                      style="height: 150px;" [(ngModel)]="article.Art_Des2">
                    </quill-editor>
                  </div>
                  <div class="txt">
                    <quill-editor [modules]="quillModules" name="tdex2" placeholder="En" [(ngModel)]="text[1][2]">
                    </quill-editor>
                  </div>
                </div>
              </mat-expansion-panel>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title> Description détaillée 2 </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="display-flex">
                  <div class="txt">
                    <!-- <quill-editor
                      [(ngModel)]="article.Art_Des1"
                      [styles]="{ height: '200px' }"
                      [placeholder]="'Fr'"
                      [modules]="editorModules"
                      theme="snow"
                    ></quill-editor> -->
                    <quill-editor [modules]="quillModules" name="tesxs1" placeholder="Fr" [(ngModel)]="text[0][3]">
                    </quill-editor>
                  </div>
                  <div class="txt">
                    <quill-editor [modules]="quillModules" name="tdedx2" placeholder="En" [(ngModel)]="text[1][3]">
                    </quill-editor>
                  </div>
                </div>
              </mat-expansion-panel>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title> Description détaillée 3 </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="display-flex">
                  <div class="txt">
                    <quill-editor [modules]="quillModules" name="tessxs1" placeholder="Fr" [(ngModel)]="text[0][4]">
                    </quill-editor>
                  </div>
                  <div class="txt">
                    <quill-editor [modules]="quillModules" name="tdesdx2" placeholder="En" [(ngModel)]="text[1][4]">
                    </quill-editor>
                  </div>
                </div>
              </mat-expansion-panel>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title> Description détaillée 4 </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="display-flex">
                  <div class="txt">
                    <quill-editor [modules]="quillModules" name="tessxss1" placeholder="Fr" [(ngModel)]="text[0][5]">
                    </quill-editor>
                  </div>
                  <div class="txt">
                    <quill-editor [modules]="quillModules" name="tdeddsdx2" placeholder="En" [(ngModel)]="text[1][5]">
                    </quill-editor>
                  </div>
                </div>
              </mat-expansion-panel>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title> Description détaillée 5 </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="display-flex">
                  <div class="txt">
                    <quill-editor [modules]="quillModules" name="tesssxss1" placeholder="Fr" [(ngModel)]="text[0][6]">
                    </quill-editor>
                  </div>
                  <div class="txt">
                    <quill-editor [modules]="quillModules" name="tdeddssdx2" placeholder="En" [(ngModel)]="text[1][6]">
                    </quill-editor>
                  </div>
                </div>
              </mat-expansion-panel>
            </mat-accordion>

            <!-- <h5>Bref description</h5>
                        <div class="display-flex">
                            <div class="txt">
                                <quill-editor [config]="editorConfig" name="tex1" placeholder="Fr" [(ngModel)]="article.Art_Des1">
                                </quill-editor>
                              </div>
                              <div class="txt">
                                <quill-editor [config]="editorConfig" name="tex2" placeholder="En" [(ngModel)]="text[1][1]">
                                </quill-editor>
                              </div>
                        </div> -->
          </mat-tab>

          <mat-tab [disabled]="activerFamilleArticle" label="Famille article">
            <br />
            <div class="add">
              <mat-icon style="color: rgb(76, 79, 230); font-size: 35px" (click)="add()">add</mat-icon>
            </div>
            <!-- add ng for to be a list  -->
            <div *ngFor="let item of ListCat; let j = index" style="border-bottom: 1px solid black; margin-bottom: 4px">
              <mat-autocomplete #autoo="matAutocomplete" (optionSelected)="categoriesNiveau1Selected($event, j)">
                <mat-option *ngFor="let categoriesNiv1 of categoriesNiveau1[j]" [id]="j + categoriesNiv1.categorie_Code"
                  [value]="categoriesNiv1.categorie_Text">
                  {{ categoriesNiv1.categorie_Text }}
                </mat-option>
              </mat-autocomplete>
              <mat-form-field style="margin-right: 10px; margin-top: 4px">
                <input (input)="onCategoriesNiveau1Valuechange($event, j)" [disabled]="disabled" matInput
                  placeholder="Catégorie" [matAutocomplete]="autoo" [name]="j + 'categoriesNiv1'"
                  #categoriesNiv1="ngModel" [(ngModel)]="catNiv1[j]" required />
              </mat-form-field>

              <!-- <mat-form-field style="margin-right: 10px;margin-top: 4px;">
                <mat-label>Catégorie</mat-label>
                <mat-select [id]="j+idCategoriesNiveau1" [(ngModel)]="catNiv1[j]"[name]="j+'categoriesNiveau2'"(optionSelected)="categoriesNiveau1Selected($event,j)">
                  <mat-option  *ngFor="let categoriesNiv1 of categoriesNiveau1[j]" [value]="categoriesNiv1.categorie_Text">
                    {{categoriesNiv1.categorie_Text}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field style="margin-right: 10px;margin-top: 4px;">
                <mat-label>Famille</mat-label>
                <mat-select [id]="j+'idCategoriesNiveau2'" [(ngModel)]="catNiv2[j]"[name]="j+'categoriesNiveau2'"(optionSelected)="categoriesNiveau2Selected($event,j)">
                  <mat-option  *ngFor="let option of categoriesNiveau2[j]" [value]="option.categorie_Text">
                    {{option.categorie_Text}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field style="margin-right: 10px;margin-top: 4px;">
                <mat-label>Sous famille</mat-label>
                <mat-select [(ngModel)]="catNiv3[j]" [id]="j+'idCategoriesNiveau3'" [name]="j+'categoriesNiveau3'"(optionSelected)="categoriesNiveau3Selected($event,j)">
                  <mat-option  *ngFor="let option of categoriesNiveau3[j]" [value]="option.categorie_Text">
                    {{option.categorie_Text}}
                  </mat-option>
                </mat-select>
              </mat-form-field> -->

              <mat-form-field style="margin-right: 10px">
                <input [disabled]="disabled" [id]="j + 'idCategoriesNiveau2'" matInput [name]="j + 'categoriesNiveau2'"
                  [matAutocomplete]="autoCategoriesNiveau2" [(ngModel)]="catNiv2[j]"
                  (input)="onCategoriesNiveau2Valuechange($event, j, false)" placeholder="Famille" />
              </mat-form-field>
              <mat-autocomplete #autoCategoriesNiveau2="matAutocomplete"
                (optionSelected)="categoriesNiveau2Selected($event, j, false)">
                <mat-option *ngFor="let option of categoriesNiveau2[j]" [id]="j + option.categorie_Code"
                  [value]="option.categorie_Text">
                  {{ option.categorie_Text }}
                </mat-option>
              </mat-autocomplete>

              <mat-form-field style="margin-right: 10px">
                <input [disabled]="disabled" [id]="j + 'idCategoriesNiveau3'" matInput [name]="j + 'categoriesNiveau3'"
                  [matAutocomplete]="autoCategoriesNiveau3" [(ngModel)]="catNiv3[j]"
                  (input)="onCategoriesNiveau3Valuechange($event, j, false)" placeholder="Sous famille" />
              </mat-form-field>
              <mat-autocomplete #autoCategoriesNiveau3="matAutocomplete"
                (optionSelected)="categoriesNiveau3Selected($event, j, false)">
                <mat-option *ngFor="let option of categoriesNiveau3[j]" [id]="option.categorie_Code"
                  [value]="option.categorie_Text">
                  {{ option.categorie_Text }}
                </mat-option>
              </mat-autocomplete>
              <span class="icon">
                <mat-icon style="color: green" (click)="update(j)">save</mat-icon>
                <mat-icon style="color: rgb(230, 99, 76)" (click)="deleteCat(j)">remove</mat-icon>
              </span>

              <!-- <div class="display-flex">
                <mat-form-field style="margin-right: 10px">
                  <mat-label>Type</mat-label>
                  <mat-select name="Art_Nature" #Art_Nature="ngModel" [(ngModel)]="article.Art_Nature">
                    <mat-option *ngFor="let type of typeArticle" [value]="type.value">{{type.type}}</mat-option>
                  </mat-select>
                </mat-form-field>
                <div style="width: 400px;" *ngIf="article && article.Art_Nature == 2">
                  <mat-form-field>
                    <input matInput [disabled]="true" name="Art_Stat5" #Art_Stat5="ngModel"
                      [(ngModel)]="article.Art_Stat5" placeholder="Article parent">
                  </mat-form-field>
                  <button matTooltip="Modifier" mat-icon-button (click)="openFrmRechercheArticle()" color="primary">
                    <mat-icon>edit</mat-icon>
                  </button>
                </div>
              </div> -->
            </div>
            <div>
              <h4>Liste articles enfants</h4>
              <app-liste #listeComponen [showFilter]="false" [heightTable]="'400'" [displayedColumnsBrut]="columns">
              </app-liste>
            </div>
          </mat-tab>
          <mat-tab [disabled]="activerDetailsArticle" label="Détails article">
            <br />
            <div fxLayout="row">
              <mat-form-field style="margin-right: 10px">
                <input [disabled]="disabled" matInput (input)="onCaracteristiqueModelValuechange($event)"
                  placeholder="Modèle" [matAutocomplete]="caracteristiqueModel" name="caracteristique_Model"
                  #caracteristique_Model="ngModel" [(ngModel)]="modelCaracteristiqueArticle.ecArtCarMod_Label" />
              </mat-form-field>
              <mat-autocomplete #caracteristiqueModel="matAutocomplete"
                (optionSelected)="caracteristiqueModelSelected($event)">
                <mat-option *ngFor="let option of listeModel" [id]="option.ecArtCarMod_Id"
                  [value]="option.ecArtCarMod_Label">
                  {{ option.ecArtCarMod_Label }}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div fxLayout="row" fxLayoutAlign="space-between none">
              <mat-form-field>
                <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter" />
              </mat-form-field>
              <div fxLayout="row">
                <div style="margin-right: 20px" class="button-row">
                  <button type="button" (click)="enregistrerCaracteristique()" mat-raised-button class="colorGreen">
                    Enregistrer détails article
                  </button>
                </div>

                <div *ngIf="typeTrs == '2'" style="margin-right: 20px" class="button-row">
                  <button type="button" (click)="supprimerDetailArticle()" mat-raised-button class="colorReed">
                    Supprimer
                  </button>
                </div>
              </div>
            </div>
            <div id="divTableCaracteristiques" class="">
              <table id="tableCaracteristiques" mat-table [dataSource]="dataSourceCaracteristique"
                class="mat-elevation-z8">
                <ng-container matColumnDef="ecArtCar_Id">
                  <th mat-header-cell *matHeaderCellDef>Code</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.ecArtCar_Id }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="ecArtCar_Label">
                  <th mat-header-cell *matHeaderCellDef>Texte</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.ecArtCar_Label }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="ecArtCar_Val">
                  <th mat-header-cell *matHeaderCellDef>Valeur</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ element.ecArtCar_Val }}&nbsp;
                    <span class="button-row">
                      <button type="button" matTooltip="Supprimer" class="bet_time" mat-button color="primary"
                        (click)="getValeurCaracteristique(element)">
                        <mat-icon>search</mat-icon>
                      </button>
                    </span>
                    <!-- <mat-form-field >
                                            <mat-select [name]="'abc'+i" #abc="ngModel" [(ngModel)]="element.ecArtCar_Val"
                                                placeholder="Introduire une valeur" required>
                                                <mat-option *ngFor="let car of getvalueCaracteristique(element.ecArtCar_Id)" [value]="car.ecArtCarValList_Id">{{car.ecArtCarValList_Label}}</mat-option>
                                            </mat-select>
                                        </mat-form-field> -->
                    <!-- <app-recherche  [recherche]="'ecArtCarValList&param='+ element.ecArtCar_Val" displayColumn="ecArtCarValList_Label" [(ngModel)]="element.ecArtCar_Val" [name]="'carVal'+ element.ecArtCar_Id" placeholder=""  ></app-recherche> -->
                    <!-- <input style="width: 100%" [disabled]="disabled" [name]="'abc'+i" #abc="ngModel"
                                            placeholder="Introduire une valeur" [(ngModel)]="element.ecArtCar_Val"> -->
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"
                  (click)="selectRow($event, row, 'caracteristique')"></tr>
              </table>
            </div>
          </mat-tab>
          <mat-tab [disabled]="activerImagesArticle" label="Images article">
            <h3>Image rectangulaire</h3>
            <div *ngFor="let color1 of listeColor1">
              <div>
                <button matTooltip="Ajouter" style="margin-right: 10px" mat-icon-button
                  [disabled]="!enregistrementTerminer" (click)="openFrmImage('ajouter', 'rectengle', color1.color)"
                  color="primary">
                  <mat-icon>cloud_upload</mat-icon>
                </button>
                <button matTooltip="Supprimer" mat-icon-button [disabled]="!enregistrementTerminer"
                  (click)="supprimerImages('rectengle', color1.color)" color="primary">
                  <mat-icon>delete</mat-icon>
                </button>
                &nbsp;&nbsp;<b *ngIf="color1.color != '-1'">Couleur :{{ color1.ArtV_Code1 }}</b>
              </div>
              <div class="display-flex">
                <!-- <mat-icon style="color:rgb(76, 79, 230)" (click)="sss()">home</mat-icon> -->
                <div *ngFor="
                    let img of filterImageByColor(
                      listeImgRectengle,
                      color1.color
                    );
                    let i = index
                  " class="image-article-carrer" (click)="
                    selectionnerImage(img, 'rectengle', color1.ArtV_Code1, i)
                  ">
                  <img #imagePrincipale [src]="
                      (useDataBaseToSaveImage == 1
                        ? ''
                        : base_url + 'images/') + img.File_Content
                    " [id]="'rectengle' + color1.ArtV_Code1 + i" class="image-article-carrer" />
                  <div>
                    <mat-select *ngIf="listeColor.length > 0" [name]="'etat' + img.File_Id" #etat="ngModel"
                      [(ngModel)]="img.File_Dll" placeholder="Couleur">
                      <mat-option *ngFor="let color of listeColor" [value]="color.color">{{ color.ArtV_Code1 }}
                      </mat-option>
                    </mat-select>

                    <mat-icon style="color: rgb(76, 79, 230)" (click)="setOrder(1, img)">add</mat-icon>
                    {{ img.File_Class }}
                    <mat-icon style="color: rgb(197, 90, 90)" (click)="setOrder(-1, img)">remove</mat-icon>
                    <br />
                    <button class="colorGreen" [disabled]="!enregistrementTerminer" mat-raised-button
                      (click)="modifierOrderImages(img, 'rectengle')">
                      <mat-icon>save</mat-icon>
                    </button>

                    <section class="example-section">
                      <mat-checkbox class="example-margin" [name]="'check' + i" [(ngModel)]="checked[i]"
                        (change)="onselectionChange($event, i, img)">Checked</mat-checkbox>
                    </section>
                  </div>
                </div>
              </div>
            </div>
            <input id="input_file99" type="file" value="importer" style="display: none"
              (change)="onChangeImagefile($event)" />
          </mat-tab>
          <mat-tab [disabled]="activerProduit" label="Produits complémentaires">
            <mat-card class="example-card">
              <mat-card-content>
                <div fxLayout="row">
                  <app-recherche recherche="ecarticleauto2" displayColumn="Art_Des" name="article"
                    (clickClearText)="ClearTextComplementaire()" [(ngModel)]="artComplementaire" placeholder="Article">
                  </app-recherche>
                  <div style="margin-left: 10px" class="button-row">
                    <button (click)="ajouterProduit('1')" [disabled]="disabled" class="bet_time" mat-raised-button
                      color="primary">
                      Ajouter
                    </button>
                  </div>
                  <!-- <div style="margin-left: 10px " class="button-row">
                    <button (click)="modifierProduitComplementaire()" [disabled]="disabled" class="bet_time"
                      mat-raised-button color="primary">modifier</button>
                  </div> -->
                  <div style="margin-left: 10px" class="button-row">
                    <button (click)="supprimerProduitComplementaire()" [disabled]="disabled" class="bet_time"
                      mat-raised-button color="primary">
                      Supprimer
                    </button>
                  </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="space-between none">
                  <mat-form-field>
                    <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter" />
                  </mat-form-field>
                </div>
                <div class="example-table-container">
                  <table id="tablecategories" mat-table [dataSource]="dataSourceProduitsComplementaire"
                    class="mat-elevation-z8">
                    <ng-container matColumnDef="ecArtComp_Code">
                      <th mat-header-cell *matHeaderCellDef>Code</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.Art_Code }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="Art_Des">
                      <th mat-header-cell *matHeaderCellDef>Désignation</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.Art_Des }}
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumnsProduits; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsProduits"
                      (click)="selectRow($event, row, 'complementaire')"></tr>
                  </table>
                </div>
              </mat-card-content>
            </mat-card>
          </mat-tab>
          <mat-tab [disabled]="activerProduit" label="Produits similaires">
            <mat-card class="example-card">
              <mat-card-content>
                <div fxLayout="row">
                  <app-recherche recherche="ecarticleauto2" displayColumn="Art_Des" name="article"
                    (clickClearText)="ClearTextSimilaires()" [(ngModel)]="artSimilaires" placeholder="Article">
                  </app-recherche>
                  <div style="margin-left: 10px" class="button-row">
                    <button (click)="ajouterProduit('2')" [disabled]="disabled" class="bet_time" mat-raised-button
                      color="primary">
                      Ajouter
                    </button>
                  </div>
                  <!-- <div style="margin-left: 10px " class="button-row">
                    <button (click)="modifierProduitSimilaires()" [disabled]="disabled" class="bet_time"
                      mat-raised-button color="primary">modifier</button>
                  </div> -->
                  <div style="margin-left: 10px" class="button-row">
                    <button (click)="supprimerProduitSimilaires()" [disabled]="disabled" class="bet_time"
                      mat-raised-button color="primary">
                      Supprimer
                    </button>
                  </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="space-between none">
                  <mat-form-field>
                    <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter" />
                  </mat-form-field>
                </div>
                <div class="example-table-container">
                  <table id="tablecategories" mat-table [dataSource]="dataSourceProduitsSimilaires"
                    class="mat-elevation-z8">
                    <ng-container matColumnDef="ecArtComp_Code">
                      <th mat-header-cell *matHeaderCellDef>Code</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.Art_Code }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="Art_Des">
                      <th mat-header-cell *matHeaderCellDef>Désignation</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.Art_Des }}
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumnsProduits; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsProduits"
                      (click)="selectRow($event, row, 'similaires')"></tr>
                  </table>
                </div>
              </mat-card-content>
            </mat-card>
          </mat-tab>
          <mat-tab [disabled]="activerProduit" label="Pdf article">
            <mat-card class="example-card">
              <mat-card-content>
                <div fxLayout="row">
                  <div>
                    <button matTooltip="Ajouter" style="margin-right: 10px" mat-icon-button
                      [disabled]="!enregistrementTerminerPDF" (click)="openFrmPdf('ajouter')" color="primary">
                      <mat-icon>cloud_upload</mat-icon>
                    </button>
                    <button matTooltip="Modifier" style="margin-right: 10px" mat-icon-button
                      [disabled]="!enregistrementTerminerPDF" (click)="openFrmPdf('modifier')" color="primary">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button matTooltip="Supprimer" mat-icon-button [disabled]="!enregistrementTerminerPDF"
                      (click)="supprimerPdf()" color="primary">
                      <mat-icon>delete</mat-icon>
                    </button>
                    <!-- <button matTooltip="Supprimer" mat-icon-button [disabled]="!enregistrementTerminer" 
                                                (click)="sss()" color="primary">
                                                <mat-icon >delete</mat-icon>
                                            </button> -->
                    <!-- &nbsp;&nbsp;<b *ngIf="color1.color != '-1'">Couleur :{{color1.ArtV_Code1}}</b> -->
                  </div>
                </div>
                <div *ngIf="article.Art_pdf" fxLayout="row">
                  <div *ngIf="article.Art_pdf" class="display-flex">
                    <img (click)="getSelectedFile(article.Art_pdf)" src="../../assets/pdf.png" />
                  </div>
                </div>
                <div *ngIf="showPdf" style="width: 90%; height: 500px" id="pdf"></div>
              </mat-card-content>
            </mat-card>
            <input id="input_file" type="file" value="importer" style="display: none"
              (change)="onChangeImagefile2($event)" />
          </mat-tab>
        </mat-tab-group>
        <br />
        <div fxLayout="row" fxLayoutAlign="space-between none">
          <div class="button-row">
            <button (click)="suivant(f)" mat-raised-button color="primary">
              Etape suivante
            </button>
          </div>

          <div *ngIf="showBtn" class="button-row">
            <button [disabled]="disabled" (click)="enregistrer(f)" mat-raised-button color="primary">
              Enregistrer article
            </button>
          </div>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
<ng-template #dialogue>
  <div class="cont">
    <div class="content-dialog" style="margin-right: 10px">
      <!-- <mat-form-field style="margin-right: 10px">
        <input (input)="onCategoriesNiveau1Valuechange($event)" [disabled]="disabled" matInput placeholder="Catégorie"
          [matAutocomplete]="autoo" name="categoriesNiv1" #categoriesNew="ngModel" [(ngModel)]="catNew" required>
      </mat-form-field> -->

      <mat-form-field style="margin-right: 10px">
        <input (input)="onCategoriesNiveau1Valuechange1($event)" [disabled]="disabled" matInput placeholder="Catégorie"
          [matAutocomplete]="autoo1" name="categoriesNiv1v1" #categorieNiv1v1="ngModel" [(ngModel)]="catNiv1v1"
          required />
      </mat-form-field>

      <mat-autocomplete #autoo1="matAutocomplete" (optionSelected)="categoriesNiveau1Selected1($event)">
        <mat-option *ngFor="let categoriesNiv1 of categoriesNiveau1v1" [id]="'1' + categoriesNiv1.categorie_Code"
          [value]="categoriesNiv1.categorie_Text">
          {{ categoriesNiv1.categorie_Text }}
        </mat-option>
      </mat-autocomplete>

      <mat-form-field style="margin-right: 10px">
        <input [disabled]="disabled" id="1idCategoriesNiveau2" matInput name="categoriesNiveau2"
          [matAutocomplete]="autoCategoriesNiveau21" [(ngModel)]="catNiv21"
          (input)="onCategoriesNiveau2Valuechange1($event)" placeholder="Famille" />
      </mat-form-field>
      <mat-autocomplete #autoCategoriesNiveau21="matAutocomplete" (optionSelected)="categoriesNiveau2Selected1($event)">
        <mat-option *ngFor="let option of categoriesNiveau2v1" [id]="'1' + option.categorie_Code"
          [value]="option.categorie_Text">
          {{ option.categorie_Text }}
        </mat-option>
      </mat-autocomplete>

      <mat-form-field style="margin-right: 10px">
        <input [disabled]="disabled" id="1idCategoriesNiveau3" matInput name="categoriesNiveau3"
          [matAutocomplete]="autoCategoriesNiveau31" [(ngModel)]="catNew"
          (input)="onCategoriesNiveau3Valuechange1($event)" placeholder="Sous famille" />
      </mat-form-field>
      <mat-autocomplete #autoCategoriesNiveau31="matAutocomplete" (optionSelected)="categoriesNiveau3Selected1($event)">
        <mat-option *ngFor="let option of categoriesNiveau31" [id]="'1' + option.categorie_Code"
          [value]="option.categorie_Text">
          {{ option.categorie_Text }}
        </mat-option>
      </mat-autocomplete>
    </div>
    <div class="action">
      <button class="mat-raised-button" (click)="closeDialog()">Close</button>
      <button class="mat-raised-button mat-primary" (click)="save()">
        Enregistrer
      </button>
    </div>
  </div>
</ng-template>